import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { articles } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20artistic%20abstract%20composition%20with%20warm%20cream%20beige%20and%20soft%20amber%20tones%2C%20flowing%20organic%20shapes%2C%20sophisticated%20editorial%20atmosphere%2C%20premium%20quality%20feel%2C%20soft%20gradients%20and%20textures&width=1920&height=900&seq=hero-bg-main&orientation=landscape"
          alt="精品久久久 - 高品质精选内容长效平台"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/15 to-black/30"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 py-20 md:py-0 text-center">
        <h1 className="font-heading font-bold text-3xl md:text-5xl lg:text-6xl text-background-50 mb-6 leading-tight">
          精品久久久
        </h1>
        <p className="text-lg md:text-xl text-background-200/90 max-w-2xl mx-auto mb-3 leading-relaxed">
          高品质精选内容长效平台
        </p>
        <p className="text-sm md:text-base text-background-300/80 max-w-xl mx-auto mb-10 leading-relaxed">
          汇聚经久不衰的优质内容与精品资源，为您提供持久、稳定、高价值的极致体验
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/shendu-yuedu"
            className="px-6 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            开始探索
          </Link>
          <Link
            to="/about"
            className="px-6 py-3 rounded-full border border-background-50/40 text-background-50 font-medium text-sm hover:bg-background-50/10 transition-colors cursor-pointer whitespace-nowrap"
          >
            了解更多
          </Link>
        </div>

        {/* Stats */}
        <div className="flex flex-wrap items-center justify-center gap-8 md:gap-12 mt-16">
          <div className="text-center">
            <div className="font-heading font-bold text-2xl md:text-3xl text-background-50">200+</div>
            <div className="text-xs md:text-sm text-background-300/80 mt-1">精选文章</div>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <div className="font-heading font-bold text-2xl md:text-3xl text-background-50">6</div>
            <div className="text-xs md:text-sm text-background-300/80 mt-1">内容分类</div>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <div className="font-heading font-bold text-2xl md:text-3xl text-background-50">50K+</div>
            <div className="text-xs md:text-sm text-background-300/80 mt-1">忠实读者</div>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <div className="font-heading font-bold text-2xl md:text-3xl text-background-50">99.7%</div>
            <div className="text-xs md:text-sm text-background-300/80 mt-1">内容好评率</div>
          </div>
        </div>
      </div>
    </section>
  );
}

export function FeaturedArticles() {
  const featured = articles.filter((a) => a.featured).slice(0, 3);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900 mb-3">
            精选推荐
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            编辑团队精心甄选的优质内容，每一篇都值得细细品读
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 md:gap-6">
          <div className="lg:col-span-2">
            {featured[0] && (
              <ArticleCard
                {...featured[0]}
                imageUrl={featured[0].imageUrl}
                variant="featured"
              />
            )}
          </div>
          <div className="flex flex-col gap-5 md:gap-6">
            {featured.slice(1).map((article) => (
              <ArticleCard
                key={article.slug}
                {...article}
                imageUrl={article.imageUrl}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900 mb-3">
            内容分类
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            六大精选栏目，满足您对不同领域精品内容的追求
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex items-start gap-4 p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all cursor-pointer"
            >
              <div className="w-11 h-11 md:w-12 md:h-12 flex-shrink-0 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${cat.icon} text-lg md:text-xl`}></i>
              </div>
              <div className="min-w-0">
                <h3 className="font-heading font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors mb-1.5 text-sm md:text-base">
                  {cat.name}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 line-clamp-2 leading-relaxed">
                  {cat.description}
                </p>
                <span className="inline-block mt-2 text-xs text-foreground-400">
                  {cat.articleCount} 篇文章
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

export function PopularArticles() {
  const popular = articles.filter((a) => a.popular).slice(0, 6);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-10 md:mb-14 gap-3">
          <div>
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900 mb-1.5">
              热门文章
            </h2>
            <p className="text-sm text-foreground-500">读者最爱看的精选内容</p>
          </div>
          <Link
            to="/category/shendu-yuedu"
            className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 cursor-pointer whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {popular.map((article) => (
            <ArticleCard
              key={article.slug}
              {...article}
              imageUrl={article.imageUrl}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export function NewsletterCTA() {
  return (
    <section className="relative py-14 md:py-20 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20abstract%20flowing%20gradient%20texture%20with%20soft%20cream%20beige%20and%20golden%20tones%2C%20minimalist%20elegant%20background%2C%20subtle%20organic%20patterns%2C%20premium%20quality%20feel&width=1920&height=600&seq=cta-newsletter-bg&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-background-950/80"></div>
      </div>

      <div className="relative z-10 max-w-2xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-background-50 mb-3">
          订阅精品久久久 Newsletter
        </h2>
        <p className="text-sm md:text-base text-background-300/80 mb-8 max-w-md mx-auto">
          每周五为您推送本周精选内容，不错过任何一篇好文章。加入50,000+位品质读者的行列。
        </p>

        <form
          data-readdy-form="true"
          id="home-newsletter-form"
          action="https://readdy.ai/api/form/d9rcracnlsngrm4lmaa0"
          method="POST"
          target="_blank"
          className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
        >
          <input
            type="email"
            name="email"
            placeholder="输入您的邮箱地址"
            required
            className="flex-1 px-4 py-3 rounded-full bg-background-50/10 border border-background-50/20 text-sm text-background-50 placeholder:text-background-400 focus:outline-none focus:border-primary-500 transition-colors"
          />
          <input
            type="text"
            name="phone_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
            className="hp-field"
          />
          <button
            type="submit"
            className="px-6 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            立即订阅
          </button>
        </form>
      </div>
    </section>
  );
}